// Module
var code = "<div id=\"V-36FDD390-9EC3-4FDE-B4D5-FB6780387B92\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding executable}\"></div> </div> ";
// Exports
export default code;